import React, { useState } from "react";
import { useDeleteEscallationLevelMutation } from "../../../../../Services/settingsAPIs/CommonAPI";
import { toast } from "react-toastify";

interface IProps {
  closeDeleteModal: () => void;
  levelName: string;
  tagId: any;
  refetch: () => void;
  selectedSlaId: any;
}

const DeleteLevel: React.FC<IProps> = ({
  closeDeleteModal,
  levelName,
  tagId,
  refetch,
  selectedSlaId,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [triggerDeleteEscallationLevel] = useDeleteEscallationLevelMutation();


  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      const payload = {
        sla_id: selectedSlaId,
        level: levelName,
      };
      const response = await triggerDeleteEscallationLevel({
        body: payload,
        id: tagId,
      }).unwrap();
      // Show toast with API response message
      if (response && typeof response === 'object') {
        console.log(response, "response");
        const msg = response[levelName]
          ? `${levelName}: ${response[levelName]}`
          : 'Deleted Successfully';
        toast.success(msg);
      } else {
        toast.success('Escalation level deleted successfully');
      }
      refetch(); // Refresh data after deletion
      closeDeleteModal();
    } catch (error) {
      console.error("Error deleting escalation level:", error);
      toast.error("Failed to delete escalation level. Please try again.");
    } finally {
      setIsDeleting(false);
    }
  };


  return (
    <div className="card-body">
      <p className="fs-5 fw-bold">
        Are you sure you want to delete the escalation level{" "}
        <strong>{levelName}</strong>?
      </p>

      <div className="d-flex justify-content-end mt-10">
        <button
          type="button"
          className="btn btn-sm btn-white btn-active-light-primary me-2"
          onClick={closeDeleteModal}
          disabled={isDeleting}
        >
          Cancel
        </button>

        <button
          type="button"
          className="btn btn-sm btn-danger"
          onClick={handleDelete}
          disabled={isDeleting}
        >
          {isDeleting ? (
            <span className="spinner-border spinner-border-sm"></span>
          ) : (
            <span className="indicator-label">Delete</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default DeleteLevel;
